
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2gkGM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb85fbc70a00740aff47aa69a121345>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a5d1fc5f3df445b$var$_react = $1a5d1fc5f3df445b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1a5d1fc5f3df445b$var$_iconNew = $1a5d1fc5f3df445b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $1a5d1fc5f3df445b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-play-overlay
 * Usage guidance:
 * Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a5d1fc5f3df445b$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $1a5d1fc5f3df445b$var$_react.default.createElement($1a5d1fc5f3df445b$var$_iconNew.default, Object.assign({
        name: "VideoPlayOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$1a5d1fc5f3df445b$var$VideoPlayOverlayIcon.displayName = 'VideoPlayOverlayIcon';
var $1a5d1fc5f3df445b$var$_default = module.exports.default = $1a5d1fc5f3df445b$var$VideoPlayOverlayIcon;

});


//# sourceMappingURL=video-play-overlay.b116095d.js.map
